import { forwardRef } from 'react';
import { Box, BoxProps, useMediaQuery, useTheme } from '@mui/material';

interface LogoProps extends BoxProps {}
const Logo = forwardRef<HTMLDivElement, LogoProps>(({ sx, ...other }, ref) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const logo = (
    <Box
      ref={ref}
      component="img"
      src="/images/logos/allo-clients-logo-512.png"
      alt="AlloClients"
      sx={{
        height: isMobile ? 48 : 56,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        ...sx,
      }}
      {...other}
    />
  );

  return <>{logo}</>;
});

export default Logo;
